import { Text, ScreenContainer, View } from "@src/components";
import { sizes } from "@src/constants/sizes";
import { PressableScale } from "pressto";
import { router } from "expo-router";
import { NumericKeyboard } from "@src/components/Pin/NumericKeyboard";
import { PinDots } from "@src/components/Pin/PinDots";
import { StyleSheet } from "react-native-unistyles";
import { usePin } from "@src/hooks/usePin";
import { useCrossFadeSpinner } from "@src/hooks/useCrossFadeSpinner";
import Animated from "react-native-reanimated";
import { ActivityIndicator } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { FocusedSystemBars } from "@src/components/FocusedSystemBars";
import { BackgroundGradient } from "@src/components/BackgroundGradient";
import { ContactUsButton } from "@src/components/ContactUsButton";

const InsertPinScreen = () => {
  const { insertPin, onChangeInsertPin, onDeleteInsertPin, insertPinError, isVerifyingPin } = usePin();
  const { theme } = useUnistyles();

  const { contentStyle, spinnerStyle } = useCrossFadeSpinner(isVerifyingPin);

  return (
    <>
      <FocusedSystemBars style="light" />
      <BackgroundGradient>
        <View style={{ flex: 1 }}>
          <ScreenContainer
            edges={["top", "bottom"]}
            style={{ backgroundColor: "transparent", flex: 1 }}
            contentMaxWidth={sizes.maxWidthSm}
          >
            <Animated.View style={[{ flex: 1 }, contentStyle]}>
              <View style={{ height: 56 }} />
              <View mt="9xl" alignItems="center">
                <Text textStyle="h3/regular" textAlign="center" style={styles.text}>
                  Insert Passcode
                </Text>
              </View>
              <View>
                <View mt="4xl" alignItems="center">
                  <PinDots pinLength={insertPin.length} />
                </View>
                {insertPinError && (
                  <View style={styles.errorContainer}>
                    <Text textStyle="sm/regular" textAlign="center" style={styles.error}>
                      {insertPinError}
                    </Text>
                  </View>
                )}
              </View>
              <View flex={1} alignItems="center">
                <NumericKeyboard
                  enabled={!(insertPin.length === 4)}
                  onPress={onChangeInsertPin}
                  onDelete={onDeleteInsertPin}
                />
              </View>
              <View my="4xl" alignItems="center" gap="sm">
                <Text textStyle="sm/regular" textAlign="center" style={styles.text}>
                  Having a problem?
                </Text>
                <View flexDirection="row" justifyContent="center" alignItems="center" gap="sm">
                  <ContactUsButton />
                  <Text textStyle="sm/regular" textAlign="center" style={styles.text}>
                    or
                  </Text>
                  <PressableScale onPress={() => router.push("/auth/logout")}>
                    <Text textStyle="sm/regular" textAlign="center" style={styles.secondaryText}>
                      Log out
                    </Text>
                  </PressableScale>
                </View>
              </View>
            </Animated.View>
          </ScreenContainer>
          <Animated.View
            style={[StyleSheet.absoluteFillObject, styles.spinner, spinnerStyle]}
            pointerEvents={isVerifyingPin ? "auto" : "none"}
          >
            <ActivityIndicator size="large" color={theme.colors.white.default} />
          </Animated.View>
        </View>
      </BackgroundGradient>
    </>
  );
};

const styles = StyleSheet.create((theme) => ({
  spinner: {
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  error: {
    color: theme.colors.status.error,
  },
  errorContainer: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: -theme.spacing["8xl"],
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: theme.colors.interactive.buttons.default_foreground,
  },
  secondaryText: {
    color: theme.colors.interactive.controls.secondary_foreground,
  },
}));

export default InsertPinScreen;
